<template>
  <div id="app">
    <div
      class="background-cover"
      style="background-size: cover;transition: background-image .6s;"
      v-lazy:background-image="info.image.url.webp_full"
    ></div>
    <div
      class="flex-center"
      style="justify-content: center; align-items: center; display: flex"
    >
      <div class="content-box card-box col-11-max">
        <div class="fancy-box">
          <h1 class="fancy-box-heading">规则</h1>
          <div class="content-section">
            <p>
              本实例严格遵守中华人民共和国政府颁布的《互联网信息服务管理办法》第十五条规定,并将此作为本实例运行的基本准则；
            </p>
            <p>
              对于含有以下内容的信息，我们将采用最严格的管理方法，予以杜绝：
            </p>
            <ul>
              <li>1. 反对宪法所确定的基本原则的</li>
              <li>2. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的</li>
              <li>3. 损害国家荣誉和利益的；</li>
              <li>4. 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
              <li>5. 破坏国家宗教政策,宣扬邪教和封建迷信的；</li>
              <li>6. 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
              <li>7. 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
              <li>8. 侮辱或者诽谤他人，侵害他们合法权益的；</li>
              <li>9. 含有中华人民共和国法律、行政法规禁止的其他内容的</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      info: null,
    };
  },
  created() {
    const _this = this;
    axios
      .get(
        "https://img.fudaoyuan.icu/api/1/random/?format=json&webp=true&md=false&scale_min=1.5"
      )
      .then((response) => {
        _this.info = response.data;
        Vue.use(VueLazyload);
      });
  },
};
</script>
<style>
body {
  display: flex;
  padding-top: 65px;
  padding-bottom: 20px;
  min-height: 100%;
  background: #fefefe;
  position: relative;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
}
</style>

